import { type ReactNode } from 'react'
import { Link } from '@muse-web/router'

import { IMAGE_RESIZE_SPEC } from '@core/image'
import { Cover } from '@ds/components'

import styles from './CollectionMiniCard.module.css'

const COVER_SIZES = '60px'

export type TCollectionMiniCardProps = {
    coverSrc: string
    coverAlt: string
    title: string
    titleHref: string
    authorLabel: string
    authorHref: string
    actions?: ReactNode
    onCardClick?: () => void
    onLinkClick?: () => void
}

export const CollectionMiniCard = ({
    coverSrc,
    coverAlt,
    title,
    titleHref,
    authorLabel,
    authorHref,
    actions,
    onCardClick,
    onLinkClick,
}: TCollectionMiniCardProps) => {
    const handleLinkClick = (event: React.MouseEvent) => {
        event.stopPropagation()
        onLinkClick?.()
    }

    const handleActionsClick = (event: React.MouseEvent) => {
        event.stopPropagation()
    }

    return (
        <div className={styles.card} role="presentation" onClick={onCardClick}>
            <div className={styles.coverBox}>
                <Cover
                    stacked
                    shouldScale={false}
                    src={coverSrc}
                    alt={coverAlt}
                    sizes={COVER_SIZES}
                    className={styles.coverImage}
                    resize={IMAGE_RESIZE_SPEC}
                />
            </div>
            <div className={styles.main}>
                <Link href={titleHref} className={styles.title} onClick={handleLinkClick}>
                    {title}
                </Link>
                <Link href={authorHref} className={styles.author} onClick={handleLinkClick}>
                    {authorLabel}
                </Link>
            </div>
            <div role="presentation" onClick={handleActionsClick}>
                {actions}
            </div>
        </div>
    )
}
